/* tslint:disable */
/* eslint-disable */
export enum UserDefaultPage {
  Dashboard = 0,
  Timeline = 1
}
